import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/home';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">精选推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选，品质保证</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredVideos.slice(0, 6).map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  {video.isHot && (
                    <span className="px-2 py-0.5 text-xs rounded-full bg-primary-500 text-white whitespace-nowrap">热播</span>
                  )}
                  {video.isNew && (
                    <span className="px-2 py-0.5 text-xs rounded-full bg-accent-500 text-white whitespace-nowrap">新上</span>
                  )}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 to-transparent">
                  <div className="flex items-center gap-3 text-xs text-white/80">
                    <span className="flex items-center gap-1">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                      </div>
                      {video.rating}
                    </span>
                    <span>{video.duration}</span>
                    {video.episodes && <span>{video.episodes}集</span>}
                  </div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-xl md:text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{video.description}</p>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                  <span>{video.views.toLocaleString()}次播放</span>
                  <span>{video.updateTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}